// extracted by mini-css-extract-plugin
module.exports = {"root":"Tab_root__1LxM9","active":"Tab_active__OdR35"};